<div>
  <div class="visual">
    <div #bannerDiv class="highlighted-product" [ngClass]="{'active-item': active}">
    </div>
    <div class="data" [ngClass]="{'play-data':isRedCarpetOrRedCarpetMore()}">
      <div class="left">
        <div #logoDiv></div>
        <h1 [ngClass]="{'play-highlighted-title':isRedCarpetOrRedCarpetMore()}" [innerHTML]="'eos-tv-shop-ii.title.' + omapiIdForTitle + '-highlighted' | translate"></h1>
      </div>
      <div class="right" *ngIf="pack">
        <app-price-per-month [textKeyWithParameter]="'price-detail-text-from-price-per-month'"
                             [priceDetail]="pack?.priceDetail"
                             [isPlay]="isRedCarpetOrRedCarpetMore()"
                             [isBannerPriceBox]="true"
                             [omapiId]="pack?.omapiId"></app-price-per-month>
      </div>
    </div>
  </div>
</div>

